"use client";

import { Table, TableBody, TableRow, TableHeader, TableHead } from "@oreme/ui";
import { useTranslations } from "next-intl";
import React, { type HTMLAttributes, type ReactElement } from "react";
import { SiteTableRow } from "@/components";
import type { Site } from "@/types";

interface SiteTableProps extends HTMLAttributes<HTMLDivElement> {
  data: Site[];
}

function SiteTable({ data }: Readonly<SiteTableProps>): ReactElement {
  const t = useTranslations("global.SiteTable");
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead className="py-1">{t("site")}</TableHead>
          <TableHead className="py-1">{t("location")}</TableHead>
          <TableHead className="py-1">{t("type")}</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {data.map((site): ReactElement => {
          return <SiteTableRow key={site.id} site={site} />;
        })}
      </TableBody>
    </Table>
  );
}

export { SiteTable, type SiteTableProps };
